import {ApiException} from '@toolify/server/src/middleware/ApiResponseMiddleware/errors/ApiException'
import {KnownError} from '@toolify/server/src/middleware/ApiResponseMiddleware/types/KnownError'
import {PermissionType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionType'

export function getDirectConversationForbiddenMessageKey(error: unknown): string | null {
  if(!(error instanceof ApiException) || error.name !== KnownError.NoPermissions) {
    return null
  }
  const missingPermissions = error.extra?.missingPermissions as PermissionType[] | undefined
  return missingPermissions?.includes(PermissionType.mentionInAgent)
    ? 'agent.chat.mentionPermissionRequired'
    : 'general.noPermissions'
}
